/**
 * Single source of truth for the displayed app version.
 *
 * The version is the root package.json `version`, injected at build time by
 * vite.config.ts as `import.meta.env.VITE_APP_VERSION` (the Vite root is
 * `client/`, so we can't import package.json across the fs.strict boundary at
 * runtime). `VITE_BUILD_NUMBER` is the native/Capacitor build counter, set by
 * CI/env and defaulting to "1".
 *
 * Render ONLY via the About section of Settings so there is exactly one
 * version surface in the product.
 */
const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;

export const APP_VERSION = env?.VITE_APP_VERSION ?? "0.0.0";
export const APP_BUILD = env?.VITE_BUILD_NUMBER ?? "1";

/** e.g. "v1.4.5 (1)" */
export const APP_VERSION_STRING = `v${APP_VERSION} (${APP_BUILD})`;
